import { PlanType } from "@/types/PlanTypes";

/** Newest first, by updated_at falling back to created_at. */
export default function sortPlansByRecency(plans: PlanType[]): PlanType[] {
  return [...plans].sort((a, b) => {
    const dateA = new Date(a.updated_at || a.created_at);
    const dateB = new Date(b.updated_at || b.created_at);
    return dateB.getTime() - dateA.getTime();
  });
}
